import { get, httpDelete, post, put } from 'api/client';
import config from 'config';
import type { PageData } from 'types/Page';
import type {
  UpdateUserParams,
  UserDetail,
  UsersFilterOptionsResponse,
  UsersListParams,
  UsersListResponse,
} from '../types/user';

export const UsersApi = {
  getList(params?: UsersListParams): Promise<UsersListResponse> {
    const queryParams = params
      ? Object.fromEntries(
          Object.entries(params).filter(([, value]) => value !== undefined),
        )
      : undefined;

    return get('/users', {
      params: queryParams,
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  getDetail(userId: number): Promise<UserDetail> {
    return get(`/users/${userId}`, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  update(
    userId: number,
    data: UpdateUserParams,
  ): Promise<{ data: UserDetail }> {
    return put(`/users/${userId}`, data, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  delete(userId: number): Promise<void> {
    return httpDelete(`/users/${userId}`, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  restore(userId: number): Promise<{ data: UserDetail }> {
    return post(`/users/${userId}/restore`, undefined, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  resetPassword(userId: number): Promise<{ status: boolean; message: string }> {
    return post(`/users/${userId}/reset-password`, undefined, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  generateInvitationLink(userId: number): Promise<{ invitation_link: string }> {
    return post(`/users/${userId}/invitation-link`, undefined, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  resendInvitation(userId: number): Promise<{ status: boolean }> {
    return post(`/users/${userId}/resend-invitation`, undefined, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  getFilterOptions(): Promise<UsersFilterOptionsResponse> {
    return get('/users/filter-options', {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },

  getAvailableProfiles(): Promise<PageData[]> {
    return get('/profiles/available', {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },
};
